exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".squared::before {\n    content: '';\n    float: left;\n    padding-top: 100%;\n}\n", ""]);

// exports
